import DataRoomDocHeader from './DataRoomDocHeader.component';

export default DataRoomDocHeader;